module.exports = __webpack_public_path__ + "static/media/portfolio1 (18).a44949f8.jpeg";